import Vue from 'vue'

import PerfectScrollbar from 'vue2-perfect-scrollbar'
Vue.use(PerfectScrollbar);
